import React, { useEffect, useRef, useState } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function SellerPaymentSuccess() {
  const [params] = useSearchParams();
  const session_id = params.get("session_id");
  const [state, setState] = useState({ phase: "polling", type: null });
  const attemptsRef = useRef(0);
  const { refresh } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    if (!session_id) { setState({ phase: "error" }); return; }
    let cancelled = false;
    const poll = async () => {
      if (cancelled) return;
      attemptsRef.current += 1;
      try {
        const { data } = await api.get(`/checkout/status/${session_id}`);
        if (data.payment_status === "paid") { setState({ phase: "paid", type: data.type }); refresh(); return; }
        if (data.status === "expired") { setState({ phase: "expired" }); return; }
      } catch {}
      if (attemptsRef.current >= 8) { setState({ phase: "timeout" }); return; }
      setTimeout(poll, 2000);
    };
    poll();
    return () => { cancelled = true; };
  }, [session_id, refresh]);

  return (
    <div data-testid="seller-payment-success-page" className="pt-32 pb-32 max-w-xl mx-auto px-4 text-center">
      {state.phase === "polling" && (<>
        <Loader2 className="w-10 h-10 text-[#05D9E8] mx-auto animate-spin" />
        <h1 className="font-display font-black text-3xl tracking-tight mt-6">Confirming…</h1>
      </>)}
      {state.phase === "paid" && (<>
        <CheckCircle2 className="w-14 h-14 text-[#CCFF00] mx-auto" />
        <h1 className="font-display font-black text-4xl tracking-tight mt-6">
          {state.type === "subscription" ? "You're Pro!" : state.type === "feature_listing" ? "Boosted!" : "Listing published."}
        </h1>
        <p className="text-zinc-400 mt-2">
          {state.type === "subscription" ? "Unlimited listings, zero per-listing fees." : state.type === "feature_listing" ? "Your product is featured for 7 days — pinned to the top of the marketplace." : "Your product is live and discoverable."}
        </p>
        <div className="flex justify-center gap-3 mt-8">
          <Link to="/seller" className="btn-primary" data-testid="back-to-seller">Back to dashboard</Link>
        </div>
      </>)}
      {(state.phase === "expired" || state.phase === "error" || state.phase === "timeout") && (<>
        <XCircle className="w-12 h-12 text-red-400 mx-auto" />
        <h1 className="font-display font-black text-3xl tracking-tight mt-6">Payment not completed.</h1>
        <button onClick={() => nav("/seller")} className="btn-primary mt-8" data-testid="back-seller-retry">Back to dashboard</button>
      </>)}
    </div>
  );
}
